import React, { useState, useEffect } from "react";
import { TiUser } from "react-icons/ti";
import { Form } from "react-bootstrap";
import Cookies from "js-cookie";
import {
  AxiosCustomGet,
  AxiosCustomPost,
  AxiosCustomPut,
} from "../../../components/axios/AxiosCustom";
import Config from "../../../components/axios/Config";
import SwalToast from "../../../components/helpers/SwalToast";
import { useHistory, Link } from "react-router-dom";
import AppRoutePath from "../../../router/AppRoutePath";
import httpclient from "../../../components/httpclient";
import Select from "react-select";
import moment from "moment";
import Title from "../../../components/common/Title/Title";
import Breadcrumb from "../../../components/common/Breadcrumb/Breadcrumb";
import { convertUserList } from "./helpers/convertUserList";
import CustomTable from "../../../components/common/Table/CustomTable";
import { initFilterInput, renderColumns } from "./constants";
import Swal from "sweetalert2";
import { convertOutletList } from "./helpers/convertOutletList";
import { convertRoleList } from "./helpers/covertRoleList";
import { Modal, Button } from "antd";
import "./index.css";
import {
  AuthorizationList,
  CanAccess,
} from "../../../components/template/authorization/Authorization";

function ListUser(props) {
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState("");
  const [records, setRecords] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [totalRecord, setTotalRecord] = useState(0);
  const [lastPage, setLastPage] = useState(0);
  const [submitting, setSubmitting] = useState(false);
  const [modalAddUser, setModalAddUser] = useState(false);
  const [modalEditUser, setModalEditUser] = useState(false);
  const [name, setName] = useState("-");
  const [email, setEmail] = useState("-");
  const [jabatan, setJabatan] = useState("-");
  const [outlet, setOutlet] = useState("-");
  const [role, setRole] = useState();
  const [roleList, setRoleList] = useState([]);
  const [outletList, setOutletList] = useState([]);
  const [id, setId] = useState();
  const [idUser, setIdUser] = useState();
  const [status, setStatus] = useState();
  const [loading, setLoading] = useState(false);
  const [tablePagination, setTablePagination] = useState({});
  const [filterInput, setFilterInput] = useState(initFilterInput);
  const [isEdit, setIsEdit] = useState(false);

  const [emailReset, setEmailReset] = useState();
  const [errorEmailReset, setErrorEmailReset] = useState();
  const [modalResetPassword, setModalResetPassword] = useState(false);
  const [modalResetSent, setModalResetSent] = useState(false);
  const [resubmit, setResubmit] = useState(false);

  const [counter, setCounter] = React.useState(60);
  const [statusCounter, setStatusCounter] = React.useState("");

  useEffect(() => {
    let counterId;
    if ((statusCounter === "active") & (counter !== 0)) {
      counterId = setTimeout(() => setCounter(counter - 1), 1000);
    }

    return () => {
      clearTimeout(counterId);
    };
  }, [counter, statusCounter]);

  useEffect(() => {
    getData();
  }, [filterInput]);

  useEffect(() => {
    getRole();
    getOutlet();
  }, []);

  const getRole = () => {
    let url = `${process.env.REACT_APP_BASE_API_URL}role`;
    AxiosCustomGet(
      url,
      Config({
        Authorization: `Bearer ${Cookies.get("access_token")}`,
      }),
      (response) => {
        setRoleList(convertRoleList(response.data.data.items));
      },
      (error) => {
        if (error.response) {
          SwalToast.fire({
            icon: "error",
            title: error.response.data,
          });
        } else {
          SwalToast.fire({
            icon: "error",
            title: "Whoops, something went wrong",
          });
        }
      }
    );
  };

  const getOutlet = () => {
    let url = `${process.env.REACT_APP_BASE_API_URL}outlet/all`;
    AxiosCustomGet(
      url,
      Config({
        Authorization: `Bearer ${Cookies.get("access_token")}`,
      }),
      (response) => {
        setOutletList(convertOutletList(response.data.data));
      },
      (error) => {
        if (error.response) {
          SwalToast.fire({
            icon: "error",
            title: error.response.data,
          });
        } else {
          SwalToast.fire({
            icon: "error",
            title: "Whoops, something went wrong",
          });
        }
      }
    );
  };

  const addUser = () => {
    let url = `${process.env.REACT_APP_BASE_API_URL}user`;
    let data = {
      employee_id: parseInt(id),
      role_id: role,
      email: email,
      password: "123456",
    };
    console.log(data);
    if (id === undefined) {
      SwalToast.fire({
        icon: "error",
        title: "ID Pegawai Belum Diisi",
      });
    } else if (role === undefined) {
      SwalToast.fire({
        icon: "error",
        title: "Role Belum Diisi",
      });
    } else {
      AxiosCustomPost(
        url,
        data,
        Config({
          Authorization: `Bearer ${Cookies.get("access_token")}`,
        }),
        (response) => {
          SwalToast.fire({
            icon: "success",
            title: response.data.message,
          });
          window.location.reload(false);
        },
        (error) => {
          console.log(error.response.data);
          if (error.response) {
            SwalToast.fire({
              icon: "error",
              title: error.response.data.error.message,
            });
          } else {
            SwalToast.fire({
              icon: "error",
              title: "Whoops, something went wrong",
            });
          }
        }
      );
    }
  };

  const submitReset = (event) => {
    event.preventDefault();
    AxiosCustomPost(
      `${process.env.REACT_APP_BASE_API_URL}auth/reset-password`,
      {
        email: isEdit ? email : emailReset,
        type: isEdit ? "reset" : "verify",
      },
      Config({
        Authorization: `Bearer ${Cookies.get("access_token")}`,
      }),
      (response) => {
        console.log(response.data.data);
        setModalResetPassword(false);
        setModalEditUser(false);
        setModalResetSent(true);
      },
      (error) => {
        if (error.response) {
          console.log(error.response.data.error);
          SwalToast.fire({
            icon: "error",
            title: error.response.data.error.message,
          });
        } else {
          console.log(error);
          SwalToast.fire({
            icon: "error",
            title: "Whoops, something went wrong",
          });
        }
      }
    );
  };

  const reSubmitReset = (event) => {
    event.preventDefault();
    AxiosCustomPost(
      `${process.env.REACT_APP_BASE_API_URL}auth/reset-password`,
      {
        email: emailReset,
      },
      Config(),
      (response) => {
        setResubmit(true);
        setModalResetPassword(false);
        setModalResetSent(true);
      },
      (error) => {
        if (error.response) {
          console.log(error.response.data.error);
          SwalToast.fire({
            icon: "error",
            title: error.response.data.error.message,
          });
        } else {
          console.log(error);
          SwalToast.fire({
            icon: "error",
            title: "Whoops, something went wrong",
          });
        }
      }
    );
  };

  const handleEdit = (user) => {
    console.log(user);
    setIsEdit(true);
    setModalEditUser(true);
    setName(user?.name);
    setEmail(user?.email);
    setEmailReset(user?.email);
    setJabatan(user.item.employee.jabatan.name);
    setOutlet(user.outlet);
    setId(user?.employeeId);
    setRole({ value: user?.item.role?.id, label: user.role });
    setStatus(user?.status === "Aktif" ? true : false);
    setIdUser(user.userId);
  };

  const handleSubmitEdit = () => {
    let url = `${process.env.REACT_APP_BASE_API_URL}user/${idUser}`;
    let data = {
      employee_id: parseInt(id),
      role_id: role.value,
      email: email,
      is_active: status,
    };
    console.log(data);
    AxiosCustomPut(
      url,
      data,
      Config({
        Authorization: `Bearer ${Cookies.get("access_token")}`,
      }),
      (response) => {
        SwalToast.fire({
          icon: "success",
          title: response.data.message,
        });
        window.location.reload(false);
        setIsEdit(false);
        console.log(response.data);
      },
      (error) => {
        console.log(error.response.data);
        if (error.response) {
          SwalToast.fire({
            icon: "error",
            title: error.response.data.error.message,
          });
        } else {
          SwalToast.fire({
            icon: "error",
            title: "Whoops, something went wrong",
          });
        }
      }
    );
  };

  const reset = () => {
    setName();
    setEmail();
    setJabatan();
    setOutlet();
    setId();
    setRole();
  };

  const handleDelete = (record) => {
    setSubmitting(true);
    let url = `${process.env.REACT_APP_BASE_API_URL}user/${record.userId}`;

    Swal.fire({
      title: "Hapus Data",
      text: "Apakah anda yakin ingin menghapus user " + record.name,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Hapus",
      cancelButtonText: "Batal",
    }).then((result) => {
      if (result.isConfirmed) {
        httpclient
          .DELETE(url)
          .then((response) => {
            SwalToast.fire({
              icon: "success",
              title: response.data.message,
            });
            window.location.reload(false);
          })
          .catch((error) => {
            console.log(error);
            if (error.response) {
              SwalToast.fire({
                icon: "error",
                title: error.response.data.error.message,
              });
            } else {
              SwalToast.fire({
                icon: "error",
                title: "Whoops, something went wrong",
              });
              setSubmitting(false);
            }
          })
          .finally(() => {
            setSubmitting(false);
          });
      }
    });
  };

  const getData = () => {
    let params = {
      search: filterInput.searchName,
      role_id: filterInput.role,
      outlet_id: filterInput.outlet,
      page: filterInput.page,
      size: parseInt(filterInput.pageSize),
    };
    setLoading(true);
    let url = `${process.env.REACT_APP_BASE_API_URL}users`;

    AxiosCustomGet(
      url,
      Config(
        {
          Authorization: `Bearer ${Cookies.get("access_token")}`,
        },
        params
      ),
      (response) => {
        setRecords(convertUserList(response.data.data.items));
        setTotalRecord(response.data.data.total_item);
        setLastPage(response.data.data.last_page);
        setLoading(false);
        setTablePagination({
          current: response.data.data?.page,
          pageSize: response.data.data?.per_page,
          total: response.data.data?.total_item,
        });
      },
      (error) => {
        setLoading(false);
        if (error.response) {
          SwalToast.fire({
            icon: "error",
            title: error.response.data,
          });
        } else {
          SwalToast.fire({
            icon: "error",
            title: "Whoops, something went wrong",
          });
        }
      }
    );
  };

  const handleTableChange = (pagination, _, sorter) => {
    setFilterInput((prev) => ({
      ...prev,
      page: pagination.current,
      size: parseInt(pagination.pageSize),
    }));
  };

  const getEmployeeById = (e) => {
    if (e.charCode == 13 && e.shiftKey == false) {
      let url = `${process.env.REACT_APP_BASE_API_URL}employee/${e.target.value}`;
      AxiosCustomGet(
        url,
        Config({
          Authorization: `Bearer ${Cookies.get("access_token")}`,
        }),
        (response) => {
          let data = response.data.data;
          console.log(response);
          let date_of_birth = moment(response.data.data.date_of_birth).format(
            "YYYY-MM-DD"
          );
          setName(data.first_name + " " + data.last_name);
          setEmail(data.email);
          setJabatan(data.jabatan.name);
          setOutlet(data.outlet.name);
        },
        (error) => {
          console.log(error);
          if (error.response) {
            SwalToast.fire({
              icon: "error",
              title: error.response.data,
            });
          } else {
            SwalToast.fire({
              icon: "error",
              title: "Whoops, something went wrong",
            });
          }
        }
      );
    }
  };

  const handleCloseModal = () => {
    setModalResetPassword(false);
    setModalResetSent(false);
    setModalEditUser(false);
    setIsEdit(false);
  };

  const handleDetail = (record) => {
    props.history.push(`/view_employee/${record.employeeId}`);
  };

  const handleSendEmail = (record) => {
    console.log(record);
    setEmailReset(record.email);
    setModalResetPassword(true);
  };

  const handleFilterChanged = (e) => {
    const { value, name } = e.target;
    if (name === "pageSize") {
      setFilterInput((prev) => ({
        ...prev,
        pageSize: parseInt(value),
      }));
    }
    if (name === "name") {
      if (e.key === "Enter" || e.keyCode === 13) {
        setFilterInput((prev) => ({
          ...prev,
          searchName: value,
        }));
      }
    }
  };

  const handleDropdown = (e) => {
    if (e.type === "outlet") {
      setFilterInput((prev) => ({
        ...prev,
        outlet: parseInt(e.value),
      }));
    }
    if (e.type === "role") {
      setFilterInput((prev) => ({
        ...prev,
        role: parseInt(e.value),
      }));
    }
  };

  return (
    <>
      <div>
        <div className="p-3">
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <div className="">
              <Title text={"Semua Akun"} />
              <Breadcrumb current={"Semua Akun"} />
            </div>
            <div
              style={{
                padding: 13,
                border: "1px solid #DCDCDC",
                borderRadius: 5,
                height: 50,
                width: 222,
              }}
            >
              <div
                style={{
                  fontSize: 18,
                  color: "#303030",
                }}
              >
                <TiUser
                  style={{ marginBottom: 5, fontSize: 24, color: "#D6D6D6" }}
                />
                <span style={{ fontWeight: 700 }}>{totalRecord}</span> Total
                Akun
              </div>
            </div>
          </div>
          <div
            style={{
              display: "flex",
              marginTop: 20,
              justifyContent: "space-between",
              alignItems: "flex-end",
            }}
          >
            <div className="d-flex" style={{ flex: 4 }}>
              <div className="mt-3 col-1 pl-0">
                <label htmlFor="show" className="">
                  Tampilkan:
                </label>
                <input
                  name="pageSize"
                  type="number"
                  className="form-control border-97A0AE"
                  value={filterInput.pageSize}
                  onChange={handleFilterChanged}
                />
              </div>
              <div className="mt-3  col-4">
                <label htmlFor="search_name" className="">
                  Nama Pegawai :
                </label>
                <input
                  name="name"
                  id="search_name"
                  type="text"
                  className="form-control border-97A0AE"
                  placeholder="Ketikkan Nama"
                  onChange={handleFilterChanged}
                  onKeyDown={handleFilterChanged}
                />
              </div>
              <div className="pl-3 mt-3 col-3">
                <label htmlFor="search_name" className="">
                  Cabang :
                </label>
                <Select
                  name="outlet"
                  options={outletList}
                  onChange={handleDropdown}
                />
              </div>
              <div className="pl-1 mt-3 col-3">
                <label htmlFor="search_name" className="">
                  Role :
                </label>
                <Select
                  name="role"
                  options={roleList}
                  onChange={handleDropdown}
                />
              </div>
              <div className="filter-bar d-flex align-items-end">
                <Button
                  type="link"
                  className="btn-action btn-reset"
                  onClick={() => setFilterInput(initFilterInput)}
                >
                  Reset semua filter
                </Button>
              </div>
            </div>
            <div
              style={{ flex: 2, display: "flex", justifyContent: "flex-end" }}
            >
              <CanAccess
                role={AuthorizationList.create_user}
                yes={
                  <Button
                    onClick={() => setModalAddUser(true)}
                    style={{
                      alignSelf: "flex-end",
                      height: 36,
                      background: "#2C465C",
                      color: "#FFF",
                      width: 180,
                      borderRadius: 6,
                    }}
                  >
                    + Tambah Akun
                  </Button>
                }
              />
            </div>
          </div>

          <div className="mt-3">
            <CustomTable
              columns={renderColumns(
                handleEdit,
                handleDelete,
                handleDetail,
                handleSendEmail
              )}
              data={records}
              loading={loading}
              handleTableChange={handleTableChange}
              pagination={tablePagination}
            />
          </div>
        </div>
      </div>

      <Modal
        centered
        title="Tambah Akun"
        visible={modalAddUser}
        onCancel={() => {
          setModalAddUser(false);
          reset();
        }}
        footer={[
          <Button
            onClick={() => {
              setModalAddUser(false);
              reset();
            }}
            style={{
              border: "0.75px solid #DCDCDC",
              borderRadius: 6,
              width: 120,
              height: 48,
              color: "#000",
              background: "#FFFFFF",
            }}
          >
            Kembali
          </Button>,
          <Button
            type="submit"
            onClick={addUser}
            style={{
              border: "0.75px solid #DCDCDC",
              borderRadius: 6,
              width: 120,
              height: 48,
              color: "#fff",
              background: "#2C465C",
            }}
          >
            Tambah
          </Button>,
        ]}
      >
        <div style={{ ...styles.containerInput, marginTop: 24 }}>
          <div style={styles.textLabel}>ID Pegawai :</div>
          <input
            required
            type="text"
            style={{ height: 30, flex: 2, marginTop: -10, marginLeft: 10 }}
            className="form-control border-97A0AE"
            placeholder="Masukkan ID Pegawai"
            onChange={(e) => setId(e.target.value)}
            onKeyPress={(e) => getEmployeeById(e)}
          />
        </div>
        <div style={styles.containerInput}>
          <div style={styles.textLabel}>Nama Pegawai :</div>
          <div style={styles.textValue}>{name}</div>
        </div>
        <div style={styles.containerInput}>
          <div style={styles.textLabel}>Email :</div>
          <div style={styles.textValue}>{email}</div>
        </div>
        <div style={styles.containerInput}>
          <div style={styles.textLabel}>Jabatan :</div>
          <div style={styles.textValue}>{jabatan}</div>
        </div>
        <div style={styles.containerInput}>
          <div style={styles.textLabel}>Cabang :</div>
          <div style={styles.textValue}>{outlet}</div>
        </div>
        <div style={styles.containerInput}>
          <div style={styles.textLabel}>Role :</div>
          <div style={styles.textValue}>
            <Select
              name="role"
              options={roleList}
              onChange={(e) => setRole(e.value)}
            />
          </div>
        </div>
      </Modal>

      <Modal
        centered
        title="Edit Akun"
        visible={modalEditUser}
        onCancel={() => {
          setModalEditUser(false);
          reset();
        }}
        footer={[
          <Button
            onClick={() => {
              setModalEditUser(false);
              reset();
            }}
            style={{
              border: "0.75px solid #DCDCDC",
              borderRadius: 6,
              width: 120,
              height: 48,
              color: "#000",
              background: "#FFFFFF",
            }}
          >
            Kembali
          </Button>,
          <Button
            type="submit"
            onClick={handleSubmitEdit}
            style={{
              border: "0.75px solid #DCDCDC",
              borderRadius: 6,
              width: 120,
              height: 48,
              color: "#fff",
              background: "#2C465C",
            }}
          >
            Simpan
          </Button>,
        ]}
      >
        <div style={{ ...styles.containerInput, marginTop: 24 }}>
          <div style={styles.textLabel}>ID Pegawai :</div>
          <input
            disabled
            type="text"
            style={{ height: 30, flex: 2, marginTop: -10, marginLeft: 10 }}
            className="form-control border-97A0AE"
            placeholder="Masukkan ID Pegawai"
            value={id}
            onChange={(e) => setId(e.target.value)}
            onKeyPress={(e) => getEmployeeById(e)}
          />
        </div>
        <div style={styles.containerInput}>
          <div style={styles.textLabel}>Nama Pegawai :</div>
          <div style={styles.textValue}>{name}</div>
        </div>
        <div style={styles.containerInput}>
          <div style={styles.textLabel}>Email :</div>
          <div style={styles.textValue}>{email}</div>
        </div>
        <div style={styles.containerInput}>
          <div style={styles.textLabel}>Jabatan :</div>
          <div style={styles.textValue}>{jabatan}</div>
        </div>
        <div style={styles.containerInput}>
          <div style={styles.textLabel}>Cabang :</div>
          <div style={styles.textValue}>{outlet}</div>
        </div>
        <div style={styles.containerInput}>
          <div style={styles.textLabel}>Role :</div>
          <div style={styles.textValue}>
            <Select
              defaultValue={role}
              name="role"
              options={roleList}
              onChange={(e) => setRole({ value: e.value, label: e.label })}
            />
          </div>
        </div>
        <div style={styles.containerInput}>
          <div style={styles.textLabel}>Status Akun :</div>
          <div style={styles.textValue}>
            <Form.Check
              id="custom-switch"
              checked={status}
              onChange={(e) => setStatus(!status)}
              style={{
                color: status ? "#6AC268" : "#F23434",
                fontWeight: 700,
                zIndex: 0,
              }}
              type="switch"
              label={status ? "Aktif" : "Non Aktif"}
            />
          </div>
        </div>
        <a
          onClick={submitReset}
          style={{ fontWeight: "bold", color: "#2C465C" }}
        >
          Reset Password
        </a>
      </Modal>

      <Modal
        // className="modal-edit"
        centered
        title={`Verifikasi`}
        visible={modalResetPassword}
        // onOk={handleSubmit}
        onCancel={handleCloseModal}
        footer={[
          <Button
            onClick={handleCloseModal}
            style={{
              border: "0.75px solid #DCDCDC",
              borderRadius: 6,
              width: 120,
              height: 48,
              color: "#000",
              background: "#FFFFFF",
            }}
          >
            Batal
          </Button>,
          <Button
            type="submit"
            onClick={submitReset}
            style={{
              border: "0.75px solid #DCDCDC",
              borderRadius: 6,
              width: 120,
              height: 48,
              color: "#fff",
              background: "#2C465C",
            }}
          >
            Kirim
          </Button>,
        ]}
      >
        <div className="my-3">
          <p>
            Link verifikasi akan di kirim ke{" "}
            <span style={{ fontWeight: "bold" }}>{emailReset}</span>.
          </p>
        </div>
      </Modal>

      <Modal
        centered
        title={`Cek Email Anda`}
        visible={modalResetSent}
        // onOk={handleSubmit}
        onCancel={handleCloseModal}
        footer={[
          <Button
            type="submit"
            onClick={handleCloseModal}
            style={{
              border: "0.75px solid #DCDCDC",
              borderRadius: 6,
              width: 120,
              height: 48,
              color: "#fff",
              background: "#2C465C",
            }}
          >
            Tutup
          </Button>,
        ]}
      >
        <div className="my-3">
          <p>
            Link untuk mengubah password sudah dikirim ke{" "}
            <span style={{ fontWeight: "bold" }}>{emailReset}</span>. Silahkan
            cek di folder spam jika tidak tersedia.
          </p>
          {/* {!resubmit && (
            <p>
              Tidak terima email?
              <a
                disabled={counter !== 0}
                onClick={counter === 0 ? reSubmitReset : null}
                className="font-weight-bold ml-1"
                style={{ color: counter !== 0 ? "#DCDCDC" : "#2C465C" }}
              >
                Kirim ulang
              </a>
              {counter !== 0 && (
                <span className="ml-1 color-DCDCDC">({counter})</span>
              )}
            </p>
          )} */}
        </div>
      </Modal>
    </>
  );
}

export default ListUser;

const styles = {
  textLabel: { color: "#A6A6A6", flex: 1, height: 40 },
  textValue: { flex: 2, height: 40 },
  containerInput: { display: "flex", alignItems: "center", marginTop: 5 },
};
